// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","metricsList":"_3Hr3UPnLmiNZsgqYWUyG3x","metricsFooter":"_3pa55gW3UNu_20Na9QpJl5"};